const name = 'chatbot';

export const UPDATE_CHAT = `${name}/UPDATE_CHAT`;

export const GET_ROOMS_LIST_REQUEST = `${name}/GET_ROOMS_LIST_REQUEST`;
export const GET_ROOMS_LIST_SUCCESS = `${name}/GET_ROOMS_LIST_SUCCESS`;
export const GET_ROOMS_LIST_FAILURE = `${name}/GET_ROOMS_LIST_FAILURE`;

export const MARK_ROOM_AS_READ_REQUEST = `${name}/MARK_ROOM_AS_READ_REQUEST`;
export const MARK_ROOM_AS_READ_SUCCESS = `${name}/MARK_ROOM_AS_READ_SUCCESS`;
export const MARK_ROOM_AS_READ_FAILURE = `${name}/MARK_ROOM_AS_READ_FAILURE`;

export const MANAGER_SEND_MESSAGE_REQUEST = `${name}/MANAGER_SEND_MESSAGE_REQUEST`;
export const MANAGER_SEND_MESSAGE_SUCCESS = `${name}/MANAGER_SEND_MESSAGE_SUCCESS`;
export const MANAGER_SEND_MESSAGE_FAILURE = `${name}/MANAGER_SEND_MESSAGE_FAILURE`;

export const SET_MANAGER_REQUEST = `${name}/SET_MANAGER_REQUEST`;
export const SET_MANAGER_SUCCESS = `${name}/SET_MANAGER_SUCCESS`;
export const SET_MANAGER_FAILURE = `${name}/SET_MANAGER_FAILURE`;

export const ARCHIVED_CHAT_REQUEST = `${name}/ARCHIVED_CHAT_REQUEST`;
export const ARCHIVED_CHAT_SUCCESS = `${name}/ARCHIVED_CHAT_SUCCESS`;
export const ARCHIVED_CHAT_FAILURE = `${name}/ARCHIVED_CHAT_FAILURE`;

export default name;
